import React, { useEffect } from 'react';
import styles from './LabelFilter.scss';
import { TreeViewSelectInput } from '@/Components/Controls/SelectInput/TreeViewSelectInput';
import { TreeItemType } from '@/Components/TreeView/TreeView';
import { FormSelectInput } from '@/Components/Controls/SelectInput/FormSelectInput';
import { FormData } from '@/ModalWindows/OrderLabelPrintModal/hooks/useOrderLabelPrintForm';
import { useOrderLabelStatusOptions } from '@/Enums/OrderLabelStatusHooks';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { FormDateInput } from '@/Components/Controls/DateInput/FormDateInput';
import { TimeRange } from '@/Components/Controls/TimeRange/TimeRange';
import { useSelector } from 'react-redux';
import { genLogisticTypesDataSelectors } from '@/Redux/DynamicData/GenLogisticTypesData/selector';
import { useLogisticTypesTreeViewOptions } from '@/Hooks/Options/useLogisticTypeOptions';
import { orderLabelPrintModalSelectors } from '@/ModalWindows/OrderLabelPrintModal/services';
import { useFormContext } from '@/Hooks/useFormWrapper';
import { dateTimeUtils } from '@/Utils';
import moment from 'moment-timezone';
import { useLocalization } from '@/Hooks';
import { userSelectors } from '@/Redux/User';

export const LabelFilter = () => {
  const {
    buttons: { Search },
  } = useLocalization();

  const { register, setValue, unregister } = useFormContext<FormData>();

  const { dateFormat } = useSelector(userSelectors.regionalSettings);
  const filterStatus = useSelector(orderLabelPrintModalSelectors.filterStatus);
  const filterLogistics = useSelector(orderLabelPrintModalSelectors.filterLogistics);
  const isAllLabelsIsPickup = useSelector(orderLabelPrintModalSelectors.isAllLabelsIsPickup);

  const filterStatusOptions = useOrderLabelStatusOptions();
  const logisticTypesOptions = useSelector(genLogisticTypesDataSelectors.logisticTypesOptions);
  const { typesTreeViewItems } = useLogisticTypesTreeViewOptions(logisticTypesOptions, filterLogistics);

  const defaultDate = moment().startOf('day').format(String(dateFormat?.value));
  const defaultRange = dateTimeUtils.createHoursRange('08:00', '18:00');

  const onChangeRange = (interval: Date[]) => {
    const startTime = dateTimeUtils.convertDateToHours(interval[0], true);
    const endTime = dateTimeUtils.convertDateToHours(interval[1], true);
    setValue('timeRange', `${startTime}-${endTime}`);
  };

  useEffect(() => {
    setValue('filterLogistics', filterLogistics);
    setValue('filterStatus', filterStatus);
  }, [filterLogistics, filterStatus]);

  useEffect(() => {
    register('filterLogistics');
    register('filterStatus');

    onChangeRange(defaultRange);

    return () => {
      unregister('filterLogistics');
      unregister('filterStatus');
    };
  }, []);

  return (
    <div>
      <div className={styles.filterWrapper}>
        <TreeViewSelectInput
          name={'filterLogistics'}
          onChange={(values: TreeItemType<number>[]) => {
            const ids = values.map((el) => el.key);
            setValue('filterLogistics', ids);
          }}
          options={typesTreeViewItems}
        />

        <FormSelectInput<FormData>
          name={'filterStatus'}
          options={filterStatusOptions}
          setValue={setValue}
          register={register}
          needClearButton={false}
        />
        <Button text={Search} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} type={'submit'} />
      </div>

      {!isAllLabelsIsPickup && (
        <div className={styles.dateWrapper}>
          <FormDateInput<FormData> name={'date'} register={register} setValue={setValue} valueForSet={defaultDate} />
          <TimeRange defaultRange={defaultRange} onChange={onChangeRange} />
        </div>
      )}
    </div>
  );
};
